import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteIcon from '@mui/icons-material/DeleteOutline';
import AudioFileOutlinedIcon from '@mui/icons-material/AudioFileOutlined';
import { Stack } from '@mui/material';
import { truncateFileName } from 'services/helpers/general/truncatedFileName';
import {
  StyledContainer,
  StyledFileInfoWrapper,
  StyledFileName,
  StyledFileSize,
  StyledIconButton,
  StyledIconWrapper,
} from './styled';

type PropTypes = {
  file: File;
  onDelete: () => void;
};

const KB = 1024;
const MB = KB * 1024;

const AudioInfoBox = ({ file, onDelete }: PropTypes) => {
  const { t } = useTranslation();

  const { size, name } = file;

  const formattedFileSize = useMemo(() => {
    if (size < KB) {
      return t('aiMusicGenerator:userLoopUploadModal:fileSizeUnits:bytes', {
        size,
      });
    }
    if (size < MB) {
      return t('aiMusicGenerator:userLoopUploadModal:fileSizeUnits:kb', {
        size: (size / KB).toFixed(2),
      });
    }
    return t('aiMusicGenerator:userLoopUploadModal:fileSizeUnits:mb', {
      size: (size / MB).toFixed(2),
    });
  }, [size, t]);

  return (
    <StyledContainer>
      <StyledFileInfoWrapper>
        <StyledIconWrapper>
          <AudioFileOutlinedIcon />
        </StyledIconWrapper>

        <Stack alignItems="flex-start">
          <StyledFileName>{truncateFileName(name)}</StyledFileName>
          <StyledFileSize>{formattedFileSize}</StyledFileSize>
        </Stack>
      </StyledFileInfoWrapper>

      <StyledIconButton onClick={onDelete}>
        <DeleteIcon />
      </StyledIconButton>
    </StyledContainer>
  );
};

export default AudioInfoBox;
